import React from "react";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Paginação visual reutilizável. Mostra primeira, última, e até 3 ao redor da atual.
 */
export function Paginacao({ pagina, totalPaginas, total, limite, irParaPagina }) {
  if (totalPaginas <= 1) return null;

  const inicio = (pagina - 1) * limite + 1;
  const fim = Math.min(pagina * limite, total);

  const paginas = [];
  for (let i = 1; i <= totalPaginas; i++) {
    if (i === 1 || i === totalPaginas || (i >= pagina - 1 && i <= pagina + 1)) {
      paginas.push(i);
    } else if (paginas[paginas.length - 1] !== "...") {
      paginas.push("...");
    }
  }

  return (
    <div className="flex items-center justify-between py-3 border-t border-zinc-100 mt-2 flex-wrap gap-3" data-testid="paginacao">
      <span className="text-xs text-zinc-500">
        Mostrando <strong className="text-zinc-700">{inicio.toLocaleString("pt-BR")}–{fim.toLocaleString("pt-BR")}</strong> de <strong className="text-zinc-700">{total.toLocaleString("pt-BR")}</strong> registros
      </span>
      <div className="flex items-center gap-1">
        <Button
          size="sm" variant="outline"
          onClick={() => irParaPagina(pagina - 1)}
          disabled={pagina === 1}
          data-testid="pag-anterior"
          className="h-8 px-2"
        >
          <ChevronLeft className="w-3.5 h-3.5" /> Anterior
        </Button>
        {paginas.map((p, idx) =>
          p === "..." ? (
            <span key={`${idx}-dots`} className="px-2 text-xs text-zinc-400">…</span>
          ) : (
            <Button
              key={p}
              size="sm"
              variant={p === pagina ? "default" : "outline"}
              onClick={() => irParaPagina(p)}
              className={`h-8 min-w-8 px-2 text-xs ${p === pagina ? "bg-orange-600 hover:bg-orange-700 text-white" : ""}`}
              data-testid={`pag-${p}`}
            >
              {p}
            </Button>
          )
        )}
        <Button
          size="sm" variant="outline"
          onClick={() => irParaPagina(pagina + 1)}
          disabled={pagina === totalPaginas}
          data-testid="pag-proxima"
          className="h-8 px-2"
        >
          Próxima <ChevronRight className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
}
